<script setup lang="ts">
import MenuItem from '~/components/navigation/MenuItem.vue'
import MenuPopover from '~/components/navigation/MenuPopover.vue'
import MenuSection from '~/components/navigation/MenuSection.vue'
import MenuColumn from '~/components/navigation/MenuColumn.vue'
import SubMenuItem from '~/components/navigation/SubMenuItem.vue'

import BenchmarkLogo from '~/assets/icons/benchmark-logo-black.svg'

const { WWW_DESKTOP_NAVIGATION } = useWwwNavigation()
</script>

<template>
  <div class="mx-5">
    <div
      class="mx-auto grid h-[4.063rem] w-full max-w-content-container grid-cols-1 grid-rows-2 items-center justify-between gap-x-2 xl:flex"
    >
      <div class="col-span-3 xl:col-span-1">
        <NuxtLink
          to="https://www.benchmarkminerals.com/"
          class="flex w-fit pb-5 pt-2"
          external
          no-prefetch
        >
          <BenchmarkLogo class="h-[34px] w-[226px]" />
        </NuxtLink>
      </div>

      <div class="flex h-full w-full items-center justify-end gap-x-1 xl:w-fit">
        <template v-for="(menu, index) in WWW_DESKTOP_NAVIGATION" :key="index">
          <!-- Link -->
          <MenuItem v-if="'href' in menu" :name="menu.name" :href="menu.href" />

          <!-- Popover -->
          <MenuItem v-else :name="menu.name" :menu-id="menu.menuId">
            <MenuPopover :class="menu.extraClass" :menu="menu">
              <MenuSection
                v-for="section in menu.sections"
                :key="section.name"
                :name="section.name"
              >
                <!-- Link Columns -->
                <template v-if="'columns' in section">
                  <MenuColumn
                    v-for="column in section.columns"
                    :key="column.name"
                    :name="column.name"
                  >
                    <SubMenuItem
                      v-for="link in column.children"
                      :key="link.href"
                      :href="link.href"
                    >
                      {{ link.name }}
                    </SubMenuItem>
                  </MenuColumn>
                </template>

                <!-- Links -->
                <template v-else>
                  <MenuColumn>
                    <SubMenuItem
                      v-for="link in section.children"
                      :key="link.href"
                      :href="link.href"
                    >
                      {{ link.name }}
                    </SubMenuItem>
                  </MenuColumn>
                </template>
              </MenuSection>
            </MenuPopover>
          </MenuItem>
        </template>

        <MenuItem name="Source" class="border-p-500" href="#" />
      </div>

      <div class="flex justify-end gap-x-3">
        <BaseLink
          href="https://www.benchmarkminerals.com/contact"
          class="h-www-button px-4 py-2 text-base font-bold leading-none"
        >
          Contact Us
        </BaseLink>
      </div>
    </div>
  </div>
</template>
